import { createSelector } from 'reselect'

import { selectActualLanguages } from 'containers/App/selectors'

import { createWizardCampaignSelector } from '../../../constants'
import { selectDefaultLocaleId } from '../selectors'

const selfPath = (state) => createWizardCampaignSelector(state).reviewAndLaunchStep
const selectLanguage = createSelector(
  selectDefaultLocaleId,
  selectActualLanguages,
  (defaultLocaleId, languageArray) => ({
    language: languageArray.filter((lang) => lang.id === defaultLocaleId)?.[0]?.name,
    localeId: defaultLocaleId,
  })
)

const selectMessageStepFields = (state) =>
  createWizardCampaignSelector(state).self.campaign?.messageStep?.fields
const selectReviewStepError = (state) => selfPath(state).error
const selectTestCampaignEmailsData = (state) => selfPath(state).testCampaignEmailsData
const selectTestCampaignData = (state) => selfPath(state).testCampaignData
const selectTestCampaignLoader = (state) => selfPath(state).testCampaignLoader
const selectUserMailboxId = (state) => selfPath(state).userMailboxId

const selectTestCampaignEmailsOptions = createSelector(
  selectTestCampaignEmailsData,
  (testCampaignEmailsData) =>
    testCampaignEmailsData.items.map(({ id, email }) => ({ value: id, label: email }))
)

export {
  selectLanguage,
  selectMessageStepFields,
  selectReviewStepError,
  selectTestCampaignEmailsData,
  selectTestCampaignEmailsOptions,
  selectTestCampaignData,
  selectTestCampaignLoader,
  selectUserMailboxId,
}
